import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { logout } from "../slices/admin/authSlice";
import avatar1 from '../assets/images/avatar-1.jpg';
import CompanySidebar from "./company_sidebar";
import { Cog, Import, LogOut, Search, UserPenIcon, FileSpreadsheet } from "lucide-react";
import { API_URL } from "../utils/constant";
import axios from "axios";
import TallySyncButton from "./tallyButton";
import TallyXMLDownloadButton from "./tallyButtonDownload";
import GlobalSearch from "./routesSearch";
import GstReturnModal from "../components/GstReturnModal";

const CompanyHeader = () => {
    const dispatch = useDispatch();
    const { admin } = useSelector((state) => state.adminauth);
    const location = useLocation();
    const isPOSRoute = location.pathname === "/pos";
    const currentPath = location.pathname.split('/').pop();
    const [companyName, setCompanyName] = useState('');
    const [username, setUserName] = useState('');
    const [showGstModal, setShowGstModal] = useState(false);
    const companyData = JSON.parse(localStorage.getItem('company'));   

    const toggleMenu = () => {
        // Get the main-wrapper element
        const mainWrapper = document.querySelector('.main-wrapper');
        // Toggle the menu-toggle class
        if (mainWrapper.classList.contains('slide-nav')) {
            mainWrapper.classList.remove('slide-nav');
        } else {
            mainWrapper.classList.add('slide-nav');
        }

    };

    useEffect(() => {

        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            setCompanyName(company.company?.company_name);
            setUserName(localStorage.getItem('user_name'));
        }
    }, [])

    const handleLogout = () => {
        dispatch(logout());
    }

    const toggleFullscreen = (e) => {
        e.preventDefault();

        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    };



    return (
        <>

            <div className={`header ${isPOSRoute && 'pos-header'}`}>
                <div className="main-header">
                    <div className="header-left active">
                        <Link to="/" className="logo logo-normal">
                            {companyData.company?.company_logo ? (
                                                        <img src={`${API_URL}${companyData.company?.company_logo}`} alt="Img" />
                                                    ):(
                                                        <img src="/logo.png" alt="Img" />
                                                    )}
                        </Link>
                        <Link to="/" className="logo logo-white">
                            {companyData.company?.company_logo? (
                                                        <img src={`${API_URL}${companyData.company?.company_logo}`} alt="Img" />
                                                    ):(
                                                        <img src="/logo.png" alt="Img" />
                                                    )}
                        </Link>
                        <Link to="/" className="logo-small">
                            {companyData.company?.company_logo ? (
                                                        <img src={`${API_URL}${companyData.company?.company_logo}`} alt="Img" />
                                                    ):(
                                                        <img src="/logo.png" alt="Img" />
                                                    )}
                        </Link>
                    </div>
                    <a onClick={toggleMenu} id="mobile_btn" className="mobile_btn" href="#sidebar">
                        <span className="bar-icon">
                            <span />
                            <span />
                            <span />
                        </span>
                    </a>
                    <ul className="nav user-menu">
                        <GlobalSearch companyName={companyName}/>
                       
                        {/* <li className="nav-item dropdown link-nav">
                            <a
                                href="#0"
                                className="btn btn-primary btn-md d-inline-flex align-items-center"
                                data-bs-toggle="dropdown"
                            >
                                <i className="ti ti-circle-plus me-1" />
                                Add New
                            </a>
                            <div className="dropdown-menu dropdown-xl dropdown-menu-center">
                                <div className="row g-2">
                                    <div className="col-md-2">
                                        <a href="category-list.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-brand-codepen" />
                                            </span>
                                            <p>Category</p>
                                        </a>
                                    </div>
                                    <div className="col-md-2">
                                        <a href="add-product.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-square-plus" />
                                            </span>
                                            <p>Product</p>
                                        </a>
                                    </div>
                                    <div className="col-md-2">
                                        <a href="category-list.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-shopping-bag" />
                                            </span>
                                            <p>Purchase</p>
                                        </a>
                                    </div>
                                    <div className="col-md-2">
                                        <a href="online-orders.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-shopping-cart" />
                                            </span>
                                            <p>Sale</p>
                                        </a>
                                    </div>
                                    <div className="col-md-2">
                                        <a href="expense-list.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-file-text" />
                                            </span>
                                            <p>Expense</p>
                                        </a>
                                    </div>
                                    <div className="col-md-2">
                                        <a href="quotation-list.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-device-floppy" />
                                            </span>
                                            <p>Quotation</p>
                                        </a>
                                    </div>
                                    <div className="col-md-2">
                                        <a href="sales-returns.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-copy" />
                                            </span>
                                            <p>Return</p>
                                        </a>
                                    </div>
                                    <div className="col-md-2">
                                        <a href="users.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-user" />
                                            </span>
                                            <p>User</p>
                                        </a>
                                    </div>
                                    <div className="col-md-2">
                                        <a href="customers.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-users" />
                                            </span>
                                            <p>Customer</p>
                                        </a>
                                    </div>
                                    <div className="col-md-2">
                                        <a href="sales-report.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-shield" />
                                            </span>
                                            <p>Biller</p>
                                        </a>
                                    </div>
                                    <div className="col-md-2">
                                        <a href="suppliers.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-user-check" />
                                            </span>
                                            <p>Supplier</p>
                                        </a>
                                    </div>
                                    <div className="col-md-2">
                                        <a href="stock-transfer.html" className="link-item">
                                            <span className="link-icon">
                                                <i className="ti ti-truck" />
                                            </span>
                                            <p>Transfer</p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li> */}
                        <TallyXMLDownloadButton />
                        <TallySyncButton />
                        <li className="nav-item pos-nav">
                            {isPOSRoute ? (
                                <Link
                                    to={'/dashboard'}
                                    className="btn btn-primary btn-md d-inline-flex align-items-center"
                                >
                                    <i className="ti ti-device-laptop me-1" />
                                    Dashboard
                                </Link>
                            ) : (<Link
                                to={'/pos'}
                                className="btn btn-dark btn-md d-inline-flex align-items-center"
                            >
                                <i className="ti ti-device-laptop me-1" />
                                POS
                            </Link>)}
                        </li>
                        <li className="nav-item nav-item-box">
                            <Link to={'#'} onClick={toggleFullscreen} id="btnFullscreen">
                                <i className={
                                    document.fullscreenElement
                                        ? "ti ti-minimize"
                                        : "ti ti-maximize"
                                } />
                            </Link>
                        </li>
                        <li className="nav-item pos-nav">
                            <Link to="/import/images" className="btn btn-success btn-md d-inline-flex align-items-center">
                                <i className="ti ti-upload me-1" /> Images
                            </Link>
                        </li>
                        <li className="nav-item dropdown has-arrow main-drop profile-nav">
                            <a
                                href="#0"
                                className="nav-link userset"
                                data-bs-toggle="dropdown"
                            >
                                <span className="user-info p-0">
                                    <span className="user-letter">
                                        <img
                                            src={avatar1}
                                            alt="Img"
                                            className="img-fluid"
                                        />
                                    </span>
                                </span>
                            </a>
                            <div className="dropdown-menu menu-drop-user">
                                <div className="profileset d-flex align-items-center">
                                    <span className="user-img me-2">
                                        <img src={avatar1} alt="Img" />
                                    </span>
                                    <div>
                                        <h6 className="fw-medium">{username || 'User'}</h6>
                                        <p>Admin</p>
                                    </div>
                                </div>
                                <Link className="dropdown-item" to={`/company-setup`}>
                                    <Cog/>
                                    Company Setup
                                </Link>
                                <hr className="my-2" />
                                <Link className="dropdown-item" to={`/profile`}>
                                    <i className="ti ti-user-circle me-2" />
                                    My Profile
                                </Link>
                                <hr className="my-2" />
                                <Link className="dropdown-item" to={`/tally/guide`}>
                                     <i className="ti ti-help me-2" />Check Tally Guide
                                </Link>
                                <hr className="my-2" />
                                <button 
                                    type="button" 
                                    className="dropdown-item d-flex align-items-center text-success fw-medium"
                                    onClick={() => setShowGstModal(true)}
                                >
                                    <FileSpreadsheet size={16} className="me-2" />
                                    GST Return (Excel)
                                </button>
                                <hr className="my-2" />
                                <Link className="dropdown-item logout pb-0" onClick={handleLogout}>
                                    <i className="ti ti-logout me-2" />
                                    Logout
                                </Link>
                            </div>
                        </li>
                    </ul>
                    <div className="dropdown mobile-user-menu">
                        <a
                            href="#0"
                            className="nav-link dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <i className="fa fa-ellipsis-v" />
                        </a>
                        <div className="dropdown-menu dropdown-menu-right">
                            {isPOSRoute ? (
                                <Link className="dropdown-item" to={`/dashboard`}>
                                    <i className="ti ti-device-laptop me-2" /> Dashboard
                                </Link>
                            ) : (
                                <Link className="dropdown-item" to={`/pos`}>
                                    <i className="ti ti-device-laptop me-2" /> POS
                                </Link>
                            )}
                            <Link className="dropdown-item" to={`/import/images`}>
                                <i className="ti ti-upload me-2" /> Images
                            </Link>
                            <hr className="my-1" />
                            <Link className="dropdown-item" to={`/company-setup`}>
                                <i className="ti ti-settings me-2" /> Company Setup
                            </Link>
                            <Link className="dropdown-item" to={`/profile`}>
                                <i className="ti ti-user-circle me-2" /> My Profile
                            </Link>
                            <Link className="dropdown-item" to={`/tally/guide`}>
                                <i className="ti ti-help me-2" /> Check Tally Guide
                            </Link>
                            <button 
                                type="button" 
                                className="dropdown-item d-flex align-items-center text-success fw-medium"
                                onClick={() => setShowGstModal(true)}
                            >
                                <FileSpreadsheet size={16} className="me-2" />
                                GST Return (Excel)
                            </button>
                            <hr className="my-1" />
                            <Link className="dropdown-item logout" onClick={handleLogout}>
                                <i className="ti ti-logout me-2 text-danger" /> Logout
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            {!isPOSRoute && <CompanySidebar />}
            <GstReturnModal isOpen={showGstModal} onClose={() => setShowGstModal(false)} />
        </>
    );
}

export default CompanyHeader;